(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19386,19341],{

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 78854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ AttachedFile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/file-to-array-buffer/index.js
var file_to_array_buffer = __webpack_require__(65379);
var file_to_array_buffer_default = /*#__PURE__*/__webpack_require__.n(file_to_array_buffer);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./utils/uploadUtils.js




var uploadFile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(signed_url, file, onUploadProgress) {
        var buffer, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        file_to_array_buffer_default()(file)
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        4,
                        api/* API.uploadFile */.b.uploadFile(signed_url, buffer, onUploadProgress)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error in the uploadFile function", {
                        error: error
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadFile(signed_url, file, onUploadProgress) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/styles.module.scss
var styles_module = __webpack_require__(18584);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx











var AttachedFile = function(props) {
    var _currentFile = props.currentFile, file = _currentFile.file, signedUrl = _currentFile.signedUrl, handleOnUnpinFile = props.handleOnUnpinFile, updateSelectedFileInfo = props.updateSelectedFileInfo;
    var ref = (0,react.useState)(false), isFileUploaded = ref[0], setIsFileUploaded = ref[1];
    var isMobile = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    (0,react.useEffect)(function() {
        if (isFileUploaded) return;
        uploadFile(signedUrl, file, function() {
            updateSelectedFileInfo(signedUrl);
            setIsFileUploaded(true);
        });
    }, [
        isFileUploaded,
        file,
        signedUrl,
        updateSelectedFileInfo, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).file,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: isMobile ? (0,lodash.truncate)(file.name, {
                    length: 20
                }) : file.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: (0,helper/* getConvertedFileSize */.IJ)(file.size)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                style: {
                    backgroundImage: "url(".concat(helper/* staticImagesUrls.unpinFile */.A6.unpinFile, ")")
                },
                "data-file-name": file.name,
                type: "button",
                onClick: handleOnUnpinFile,
                disabled: !isFileUploaded,
                "aria-label": "Unpin"
            })
        ]
    }, "file/".concat(file.name));
};
AttachedFile.propTypes = {
    currentFile: prop_types_default().shape({
        file: prop_types_default().instanceOf(Object).isRequired,
        signedUrl: (prop_types_default()).string.isRequired
    }).isRequired,
    handleOnUnpinFile: (prop_types_default()).func.isRequired,
    updateSelectedFileInfo: (prop_types_default()).func.isRequired
};


/***/ }),

/***/ 98973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SectionSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./UI/components/TextField/index.jsx + 1 modules
var TextField = __webpack_require__(79228);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx + 1 modules
var AttachedFile = __webpack_require__(78854);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./UI/components/ServicesContactForm/model/prices.js
var PRICES = {
    0: "20-50k",
    1: "50-100k",
    2: "100-500K",
    3: "> 1,000K"
};

// EXTERNAL MODULE: ./UI/components/ServicesContactForm/ui/styles.module.scss
var styles_module = __webpack_require__(17095);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/ServicesContactForm/ui/Prices.jsx






var PriceSelector = function(param) {
    var setValue = param.setValue;
    var ref = (0,react.useState)(null), selectedPrice = ref[0], setPrice = ref[1];
    var handleSelect = function(value) {
        setValue("price", value);
        setPrice(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (styles_module_default())["prices-title"],
                children: "Your budget (USD)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["price-list"],
                children: Object.keys(PRICES).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((styles_module_default()).price, (0,_define_property/* default */.Z)({}, (styles_module_default()).checked, selectedPrice === PRICES[key])),
                        onClick: function() {
                            return handleSelect(PRICES[key]);
                        },
                        children: PRICES[key]
                    }, key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./UI/components/ServicesContactForm/ui/FormAlert.jsx






var FormAlert = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), _ = ref[0], isSuccess = ref[1].isSuccess;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default())["form-alert"], (0,_define_property/* default */.Z)({}, (styles_module_default()).onSuccess, isSuccess)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "\uD83D\uDE4C Thanks!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We have received your request. We will back in a flash ⚡"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./UI/components/ServicesContactForm/model/use-upload.js





/* harmony default export */ function use_upload(props) {
    var setFiles = props.setFiles, selectedFiles = props.selectedFiles;
    var handleFilesChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var files, arrFiles, i, ref, signedUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        files = param.target.files;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        arrFiles = [];
                        i = 0;
                        _state.label = 2;
                    case 2:
                        if (!(i < files.length)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            api/* API.getFileSignedURL */.b.getFileSignedURL(files[i].name)
                        ];
                    case 3:
                        ref = _state.sent(), signedUrl = ref.data;
                        arrFiles.push({
                            file: files[i],
                            signedUrl: signedUrl,
                            isUploaded: false
                        });
                        _state.label = 4;
                    case 4:
                        i += 1;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        setFiles((0,_to_consumable_array/* default */.Z)(selectedFiles).concat((0,_to_consumable_array/* default */.Z)(arrFiles)));
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error("Error in the handleOnSelectedFilesChange function", {
                            error: error
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectedFiles,
        setFiles, 
    ]);
    var handleOnUnpinFile = function(param) {
        var dataset = param.target.dataset;
        setFiles(selectedFiles.filter(function(selectedFile) {
            return selectedFile.file.name !== dataset.fileName;
        }));
    };
    var updateSelectedFileInfo = function(signedUrl) {
        var filesArray = selectedFiles.map(function(file) {
            if (file.signedUrl === signedUrl) {
                file.isUploaded = true;
            }
            return file;
        });
        setFiles((0,_to_consumable_array/* default */.Z)(filesArray));
    };
    return {
        selectedFiles: selectedFiles,
        handleFilesChange: handleFilesChange,
        handleOnUnpinFile: handleOnUnpinFile,
        updateSelectedFileInfo: updateSelectedFileInfo
    };
};

;// CONCATENATED MODULE: ./UI/components/ServicesContactForm/ui/ContactForm.jsx



















var ContactForm = function() {
    var ref = (0,react.useState)([]), selectedFiles = ref[0], setFiles = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), sendForm = ref1[0], ref2 = ref1[1], isSuccess = ref2.isSuccess, isLoading = ref2.isLoading, isError = ref2.isError;
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, reset = ref3.reset, setValue = ref3.setValue, getValues = ref3.getValues, dirtyFields = ref3.formState.dirtyFields;
    var ref4 = use_upload({
        setFiles: setFiles,
        selectedFiles: selectedFiles
    }), handleFilesChange = ref4.handleFilesChange, handleOnUnpinFile = ref4.handleOnUnpinFile, updateSelectedFileInfo = ref4.updateSelectedFileInfo;
    var submitHandler = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, event) {
            var attachments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        attachments = selectedFiles.map(function(file) {
                            return file.signedUrl;
                        });
                        return [
                            4,
                            sendForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                attachments: attachments,
                                projectBudget: values.price || "",
                                description: values.description
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (isSuccess) {
                            setFiles([]);
                            reset();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(values, event) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: classnames_default()((styles_module_default()).form, (0,_define_property/* default */.Z)({}, (styles_module_default()).onSuccess, isSuccess)),
                onSubmit: submitHandler,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: (styles_module_default())["form-title"],
                                children: "Get in touch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default())["form-description"],
                                children: "Share your project goals with us and let's kick things off."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).formFields,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                name: "name",
                                register: register,
                                placeholder: "Name *",
                                errorMessage: "Required field",
                                required: dirtyFields.name,
                                className: classnames_default()((styles_module_default()).input, (styles_module_default()).imputName)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                name: "phone",
                                register: register,
                                placeholder: "Phone number",
                                errorMessage: "Incorrect phone number",
                                type: "tel",
                                className: classnames_default()((styles_module_default()).input, (styles_module_default()).imputPhone)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                name: "email",
                                register: register,
                                placeholder: "Email *",
                                errorMessage: "Incorrect email address",
                                required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.email,
                                type: "email",
                                className: classnames_default()((styles_module_default()).input, (styles_module_default()).imputEmail)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                name: "description",
                                register: register,
                                placeholder: "Project Details *",
                                errorMessage: "Required field",
                                required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.description,
                                className: classnames_default()((styles_module_default()).input, (styles_module_default()).imputDescription),
                                rows: 3,
                                textarea: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSelector, {
                        register: register,
                        setValue: setValue,
                        getValues: getValues
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["form-footer"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                className: (styles_module_default())["submit-button"],
                                disabled: isLoading,
                                children: "Send message"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).uploadFile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "file-input",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                            type: constants/* SVG_IMAGES_TYPES.attachment */.NL.attachment
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Attach file"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "file-input",
                                            type: "file",
                                            onChange: handleFilesChange,
                                            multiple: true,
                                            className: (styles_module_default()).hide
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    isError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default())["error-message"],
                        children: "There was an error trying to send your message. Please try again later"
                    }),
                    !!selectedFiles.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).attachedFiles,
                        children: [
                            selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.map(function(file) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachedFile/* AttachedFile */.s, {
                                    handleOnUnpinFile: handleOnUnpinFile,
                                    currentFile: file,
                                    updateSelectedFileInfo: updateSelectedFileInfo
                                }, file.signedUrl);
                            }),
                            selectedFiles && !!(selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).moreFilesLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "file-input-more",
                                    children: [
                                        "add more files",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "file-input-more",
                                            type: "file",
                                            onChange: handleFilesChange,
                                            multiple: true,
                                            className: (styles_module_default()).hide
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAlert, {})
        ]
    });
};

;// CONCATENATED MODULE: ./UI/components/SectionSelector/index.jsx









var Intro = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(19528), __webpack_require__.e(7306)]).then(__webpack_require__.bind(__webpack_require__, 25631));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25631)
            ];
        }
    }
});
var PhotoGallery = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(32998)]).then(__webpack_require__.bind(__webpack_require__, 39284));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39284)
            ];
        }
    }
});
var CaseProcess = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(48521), __webpack_require__.e(7797)]).then(__webpack_require__.bind(__webpack_require__, 96366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96366)
            ];
        }
    }
});
var TabsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(13971), __webpack_require__.e(5783)]).then(__webpack_require__.bind(__webpack_require__, 76974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76974)
            ];
        }
    }
});
var ReviewsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(8084)]).then(__webpack_require__.bind(__webpack_require__, 77359));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77359)
            ];
        }
    }
});
var CaseParallax = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(88840), __webpack_require__.e(52238)]).then(__webpack_require__.bind(__webpack_require__, 97736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97736)
            ];
        }
    }
});
var CardsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(2013), __webpack_require__.e(56012)]).then(__webpack_require__.bind(__webpack_require__, 90058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90058)
            ];
        }
    }
});
var Images = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(83628), __webpack_require__.e(75978)]).then(__webpack_require__.bind(__webpack_require__, 53435));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53435)
            ];
        }
    }
});
var ProcessSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(70600), __webpack_require__.e(15805), __webpack_require__.e(95436), __webpack_require__.e(91058)]).then(__webpack_require__.bind(__webpack_require__, 35845));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35845)
            ];
        }
    }
});
var SvgListSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(94407)]).then(__webpack_require__.bind(__webpack_require__, 12076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12076)
            ];
        }
    }
});
var NewPersonIntro = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(42884)]).then(__webpack_require__.bind(__webpack_require__, 12563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12563)
            ];
        }
    }
});
var PlainTextSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(46680), __webpack_require__.e(83509), __webpack_require__.e(99257)]).then(__webpack_require__.bind(__webpack_require__, 57149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57149)
            ];
        }
    }
});
var YoutubeVideosSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(76116)]).then(__webpack_require__.bind(__webpack_require__, 27393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27393)
            ];
        }
    }
});
var Blog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(23382), __webpack_require__.e(81965)]).then(__webpack_require__.bind(__webpack_require__, 58419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58419)
            ];
        }
    }
});
var CardsSlider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(50350)]).then(__webpack_require__.bind(__webpack_require__, 35637));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35637)
            ];
        }
    }
});
var SvgList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(90934)]).then(__webpack_require__.bind(__webpack_require__, 15804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15804)
            ];
        }
    }
});
var Card = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(45910)]).then(__webpack_require__.bind(__webpack_require__, 45910));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45910)
            ];
        }
    }
});
var Works = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(65781)]).then(__webpack_require__.bind(__webpack_require__, 80935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80935)
            ];
        }
    }
});
var PageIntroSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(46680), __webpack_require__.e(99529)]).then(__webpack_require__.bind(__webpack_require__, 13189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13189)
            ];
        }
    }
});
var FaqSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(49119), __webpack_require__.e(37255)]).then(__webpack_require__.bind(__webpack_require__, 65016));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65016)
            ];
        }
    }
});
var AssessmentSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(54526)]).then(__webpack_require__.bind(__webpack_require__, 69726));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69726)
            ];
        }
    }
});
var SectionSelector = function(props) {
    var introSection = props.introSection, data = props.data, type = props.type;
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "type"
    ]), sectionType = ref.type;
    switch(sectionType){
        case constants/* SECTION_TYPES.intro */.Oc.intro:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                introSection: introSection,
                type: type,
                data: data === null || data === void 0 ? void 0 : data.fields
            });
        case constants/* SECTION_TYPES.personIntro */.Oc.personIntro:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPersonIntro, {
                introSection: introSection,
                type: type,
                data: data === null || data === void 0 ? void 0 : data.fields
            });
        case constants/* SECTION_TYPES.plainTextSection */.Oc.plainTextSection:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainTextSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: data
            }));
        case constants/* SECTION_TYPES.youtubeVideos */.Oc.youtubeVideos:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeVideosSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: data
            }));
        case constants/* SECTION_TYPES.caseProcess */.Oc.caseProcess:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseProcess, {
                data: data === null || data === void 0 ? void 0 : data.fields,
                type: type
            });
        case constants/* SECTION_TYPES.tabs */.Oc.tabs:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsSection, {
                section: data,
                type: type
            });
        case constants/* SECTION_TYPES.review */.Oc.review:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection, {
                section: data,
                type: type
            });
        case constants/* SECTION_TYPES.parallax */.Oc.parallax:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseParallax, {
                data: data === null || data === void 0 ? void 0 : data.fields,
                type: type
            });
        case constants/* SECTION_TYPES.images */.Oc.images:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
                data: data === null || data === void 0 ? void 0 : data.fields,
                type: type
            });
        case constants/* SECTION_TYPES.photos */.Oc.photos:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoGallery, {
                sectionData: data,
                type: type
            });
        case constants/* SECTION_TYPES.appDevelopmentSvgList */.Oc.appDevelopmentSvgList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgListSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* SECTION_TYPES.appDevelopmentProcess */.Oc.appDevelopmentProcess:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* SECTION_TYPES.appDevelopmentCards */.Oc.appDevelopmentCards:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* SECTION_TYPES.svgList */.Oc.svgList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgList, {
                section: data,
                type: type
            });
        case constants/* SECTION_TYPES.cardsSlider */.Oc.cardsSlider:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider, {
                section: data,
                type: type
            });
        case constants/* SECTION_TYPES.portfolio */.Oc.portfolio:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Works, {
                section: data,
                type: type
            });
        case constants/* SECTION_TYPES.card */.Oc.card:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                data: data,
                type: type
            });
        case constants/* SECTION_TYPES.cards */.Oc.cards:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, {
                data: data,
                type: type,
                sectionType: "cards"
            });
        case constants/* SECTION_TYPES.cta */.Oc.cta:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseProcess, {
                data: data.fields,
                type: type,
                rightSide: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {})
            });
        case constants/* SECTION_TYPES.blog */.Oc.blog:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog, (0,_object_spread/* default */.Z)({
                sectionData: data
            }, props));
        case constants/* SECTION_TYPES.pageIntro */.Oc.pageIntro:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageIntroSection, (0,_object_spread/* default */.Z)({
                introSection: introSection,
                section: data
            }, props));
        case constants/* SECTION_TYPES.faq */.Oc.faq:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, (0,_object_spread/* default */.Z)({
                section: data
            }, props));
        case constants/* SECTION_TYPES.assessmentSection */.Oc.assessmentSection:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssessmentSection, (0,_object_spread/* default */.Z)({
                section: data
            }, props));
        default:
            return null;
    }
};
SectionSelector.propTypes = {
    introSection: prop_types_default().shape({}),
    data: prop_types_default().shape({
        fields: prop_types_default().shape({})
    }),
    type: (prop_types_default()).string
};
/* harmony default export */ var components_SectionSelector = (SectionSelector);


/***/ }),

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./UI/components/TextField/styles.module.scss
var styles_module = __webpack_require__(91979);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/TextField/utils/useProps.js








/* harmony default export */ function useProps(props) {
    var textarea = props.textarea, style = props.style, classNameProp = props.className, errorMessage = props.errorMessage, attached = props.attached, register = props.register, name = props.name, placeholder = props.placeholder, type = props.type, required = props.required, minLength = props.minLength, maxLength = props.maxLength, rows = props.rows, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "textarea",
        "style",
        "className",
        "errorMessage",
        "attached",
        "register",
        "name",
        "placeholder",
        "type",
        "required",
        "minLength",
        "maxLength",
        "rows"
    ]);
    var Component = textarea ? "textarea" : "input";
    var inputRef = (0,react.useRef)(null);
    var inputRegister = register && register(name, {
        required: required,
        pattern: {
            value: type === "email" && /\S+@\S+\.\S+/
        },
        minLength: minLength,
        maxLength: maxLength
    });
    var _obj;
    var className = classnames_default()(classNameProp, (styles_module_default()).input, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).attached, attached), _obj));
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps, inputRegister), {
        required: required,
        placeholder: placeholder,
        type: type,
        tabIndex: "0",
        rows: rows || 1,
        ref: register ? function(el) {
            inputRegister.ref(el);
            inputRef.current = el;
        } : inputRef
    });
    (0,react.useEffect)(function() {
        if (textarea && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) (0,autosize_esm/* default */.Z)(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    }, [
        textarea
    ]);
    return {
        Component: Component,
        className: className,
        options: options,
        errorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./UI/components/TextField/index.jsx





var TextField = function(props) {
    var ref = useProps(props), Component = ref.Component, className = ref.className, options = ref.options, errorMessage = ref.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        role: "textbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, options)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).error,
                tabIndex: "-1",
                children: errorMessage
            })
        ]
    });
};
TextField.defaultProps = {
    type: "text",
    errorMessage: "Fill empty field"
};
TextField.propTypes = {
    register: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    value: (prop_types_default()).func,
    style: (prop_types_default()).string,
    textarea: (prop_types_default()).bool,
    required: (prop_types_default()).bool,
    type: (prop_types_default()).string,
    name: (prop_types_default()).string,
    placeholder: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string,
    pattern: (prop_types_default()).string,
    errorMessage: (prop_types_default()).string,
    attached: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number
};
/* harmony default export */ var components_TextField = (TextField);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 38067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/microdata/data.js
var data = __webpack_require__(13107);
// EXTERNAL MODULE: ./utils/microdata/utils.js
var utils = __webpack_require__(20281);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./utils/microdata/deprecatedData.js




var _obj;
// TODO: Replace with actual data ASAP
var deprecatedData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareDevelopmentPrice.slug */.y2.softwareDevelopmentPrice.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Pricing: Hire a Team for Your Project | Yellow",
    description: "Calculate how much money you will need to build your software.\n    We only bill for the time actually spent on work, so it's easy to manage the budget. No extra fees.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.penetrationTesting.slug */.y2.penetrationTesting.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Penetration testing  | Yellow",
    description: "Use penetration testing to make sure your software solution is safe for your users. " + "Yellow will provide you with penetration testing services.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customMobileApp.slug */.y2.customMobileApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom mobile app development company | Yellow",
    description: "The best talents for Mobile App Development are here. Hire an experienced team to work on your idea.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.iosDevelopmentServices.slug */.y2.iosDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "iOS Mobile App Development Company | Yellow",
    description: "Yellow can provide you with iOS development services. If you want to create an iPhone or " + "iPad app, we are here to help.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.androidDevelopmentServices.slug */.y2.androidDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom Android App Development Company | Yellow",
    description: "Yellow is ready to provide you with Android development services to bring your idea to life.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.prototypingServices.slug */.y2.prototypingServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Mobile App Prototyping Services | Yellow",
    description: "Prototyping is an important stage in mobile app development. Complete it with Yellow!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customWebApp.slug */.y2.customWebApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Web Application Development Services | Yellow",
    description: "Our team is ready to provide you with web development services. " + "We are working with websites, PWAs, chatting applications, and landing pages.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareQualityAssuranceServices.slug */.y2.softwareQualityAssuranceServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Software Quality Assurance and Testing Services | Yellow",
    description: "Quality assurance is an important part of software product creation since it ensures that users" + " will receive a convenient and fully-functional solution. If you need QA services, Yellow is ready to provide them!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crowdfundingPlatform.slug */.y2.crowdfundingPlatform.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Crowdfunding Platform Development Company | Yellow",
    description: "Yellow is ready to provide you with crowdfunding platform development services. " + "High quality, realistic budget estimate, fast speed.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.fintechDevelopment.slug */.y2.fintechDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Fintech Software Development Services | Yellow",
    description: "The fintech industry is booming and doesn't seem to stop. Let's see how your " + "idea can take the slice of pie?",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.designServices.slug */.y2.designServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "UI/UX design services | Yellow",
    description: "Visual content matters, that is where UI/UX design comes into play.Users love good-looking " + "software. Make mobile your app or website captivating with Yellow.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.discoveryPhase.slug */.y2.discoveryPhase.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Project Discovery Phase in Custom Software Development | Yellow",
    description: "Discovery phase of a project is an important part of software development. " + "Learn more about how Yellow runs a discovery phase to benefit your business."
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.eWalletAppDevelopment.slug */.y2.eWalletAppDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "E-Wallet App Development Company | Yellow",
    description: "Mobile e-wallet app development services for any industry and any business scale.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.bankingSoftwareDevelopmentCompany.slug */.y2.bankingSoftwareDevelopmentCompany.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Banking Software Development Company | Yellow",
    description: "We provide companies and organizations big and small with outstanding banking software " + "development. Check out what we can do for you.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.deliveryQualityInYellow.slug */.y2.deliveryQualityInYellow.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "What Makes Yellow a Good Software Development Partner | Yellow",
    description: "Delivery quality standards we follow to build a perfect project for YOU.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.pwaDevelopmentServices.slug */.y2.pwaDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "PWA Development Services | Yellow",
    description: "Yellow is combining web and mobile worlds and creates progressive web " + "apps that function smoothly on all devices.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.paymentGatewayDevelopment.slug */.y2.paymentGatewayDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Payment Software Gateway Development Company | Yellow",
    description: "Yellow is a leading Payment Gateway Development company, providing customized " + "solutions to enhance transaction security and accuracy. Read more about our services now.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.billingSoftwareDevelopment.slug */.y2.billingSoftwareDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Billing Software Development Services Company | Yellow",
    description: "If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crossPlatformDevelopmentServices.slug */.y2.crossPlatformDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Cross-Platform App Development Services | Yellow",
    description: "Your cross-platform application will rock the stage and Yellow is ready to make it happen.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.devOpsDevelopment.slug */.y2.devOpsDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "DevOps Development Company | Yellow",
    description: "If your company wants to integrate DevOps service into its processes and get all " + "the benefits this technology offers, Yellow is ready to lend a hand!",
    image: data/* logoUrl */.pt
}), _obj);

;// CONCATENATED MODULE: ./utils/microdata/index.js






function getPageMicrodata(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, breadcrumbs = ref.breadcrumbs, microData = ref.microData;
    var microdataArray = [
        // TODO: uncomment when deprecated data will be replaced
        // webpageMicrodata,
        data/* websiteMicrodata */.IR,
        data/* organisationMicrodata */.nW, 
    ];
    var breadcrumbsMicrodata = (0,utils/* getBreadcrumbsMicrodata */.js)(breadcrumbs);
    if (breadcrumbsMicrodata) {
        microdataArray.push(breadcrumbsMicrodata);
    }
    switch(page){
        case constants/* ROUTES.homepage.slug */.y2.homepage.slug:
        case constants/* ROUTES.contact.slug */.y2.contact.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            break;
        case constants/* ROUTES.company.slug */.y2.company.slug:
        case constants/* ROUTES.whyUs.slug */.y2.whyUs.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            microdataArray.push(data/* aboutPageMicrodata */.WN);
            break;
        case constants/* ROUTES.blog.slug */.y2.blog.slug:
        case constants/* ROUTES.portfolio.slug */.y2.portfolio.slug:
        case constants/* ROUTES.project.slug */.y2.project.slug:
        case constants/* ROUTES.process.slug */.y2.process.slug:
        case constants/* ROUTES.termsAndConditions.slug */.y2.termsAndConditions.slug:
        case constants/* ROUTES.cookiesPolicy.slug */.y2.cookiesPolicy.slug:
        case constants/* ROUTES.privacyPolicy.slug */.y2.privacyPolicy.slug:
            break;
        case constants/* ROUTES.article.slug */.y2.article.slug:
            microdataArray.push((0,utils/* getArticleMicrodata */.WK)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, microData), {
                organisationMicrodata: data/* organisationMicrodata */.nW
            })));
            break;
        case constants/* ROUTES.person.slug */.y2.person.slug:
            microdataArray.push((0,utils/* getPersonMicrodata */.RK)(microData));
            break;
        default:
            var currentRoute = Object.values(constants/* ROUTES */.y2).find(function(route) {
                return route.slug === page;
            });
            var oldData = deprecatedData[page];
            if (oldData) {
                microdataArray.push(oldData);
                break;
            }
            microdataArray.push((0,utils/* getServiceMicrodata */.fi)(currentRoute, {
                organisationMicrodata: data/* organisationMicrodata */.nW,
                category: data/* CATEGORY */.En[page],
                offers: data/* OFFERS */.jn[page],
                addresses: data/* addresses */.UB
            }));
            break;
    }
    return microdataArray;
}

;// CONCATENATED MODULE: ./components/Common/MetaTags/utils/data.js
var defaultMetadata = {
    title: "Trusted AI Transformation Agency | Yellow",
    description: "We help businesses turn their AI initiatives into production-grade solutions with measurable results."
};

;// CONCATENATED MODULE: ./components/Common/MetaTags/index.jsx
/* eslint-disable react/jsx-max-props-per-line */ 






var MetaTags = function(param) {
    var page = param.page, pageMetadata = param.pageMetadata, children = param.children, breadcrumbs = param.breadcrumbs, microData = param.microData, isArticle = param.isArticle;
    var metaTitle = pageMetadata.metaTitle, metaDescription = pageMetadata.metaDescription, metaRobots = pageMetadata.metaRobots, image = pageMetadata.image, publishedAt = pageMetadata.publishedAt, categoryTag = pageMetadata.categoryTag, keyWords = pageMetadata.keyWords, pageNumber = pageMetadata.pageNumber, url = pageMetadata.url, ogImage = pageMetadata.ogImage;
    var microdata = getPageMicrodata(page, {
        breadcrumbs: breadcrumbs,
        microData: microData
    });
    var getTitle = function() {
        return pageNumber > 1 ? "".concat(metaTitle || defaultMetadata.title, " | Page ").concat(pageNumber) : metaTitle || defaultMetadata.title;
    };
    var getDescription = function() {
        return pageNumber > 1 ? "".concat(metaDescription || defaultMetadata.description, " | Page ").concat(pageNumber) : metaDescription || defaultMetadata.description;
    };
    var getImage = function() {
        if (ogImage) return ogImage;
        if (isArticle) return image;
        return (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png");
    };
    var date = isArticle ? publishedAt : new Date();
    var type = isArticle ? "article" : "website";
    var title = getTitle();
    var description = getDescription();
    var robots = !constants/* IS_PROD */.XK ? "none" : metaRobots;
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "date",
                content: date
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: getImage()
            }),
            categoryTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: categoryTag
            }),
            publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedAt
            }),
            keyWords === null || keyWords === void 0 ? void 0 : keyWords.map(function(keyWord) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "article:tag",
                    content: keyWord
                }, "meta/tag/".concat(keyWord));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (0,helper/* getPathWithCdn */.d6)("/yellow_logo.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: (0,helper/* getPathWithCdn */.d6)("/safari-pinned-tab.svg"),
                color: "#ffbf02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "application/ld+json/microdata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(microdata, null, 2)
                }
            })
        ]
    }));
};
MetaTags.defaultProps = {
    children: null,
    pageMetadata: {},
    articleData: {},
    breadcrumbs: [],
    isArticle: false
};
MetaTags.propTypes = {
    page: (prop_types_default()).string.isRequired,
    breadcrumbs: prop_types_default().instanceOf(Array),
    articleData: prop_types_default().instanceOf(Object),
    pageMetadata: prop_types_default().shape({
        metaTitle: (prop_types_default()).string,
        metaDescription: (prop_types_default()).string,
        metaRobots: (prop_types_default()).string,
        image: (prop_types_default()).string,
        ogImage: (prop_types_default()).string,
        publishedAt: (prop_types_default()).string,
        categoryTag: (prop_types_default()).string,
        keyWords: prop_types_default().instanceOf(Array),
        pageNumber: (prop_types_default()).number
    }),
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array,
        (prop_types_default()).element, 
    ]),
    isArticle: (prop_types_default()).bool,
    defaultMetaData: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var Common_MetaTags = (MetaTags);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oO": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* unused harmony exports useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96076);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91217);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);












var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                queryFn: function queryFn(value) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var client, ref, ref1, response, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: {}
                                            }
                                        ];
                                    }
                                    client = utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_FALLBACK_CONTENTFUL.includes */ .Bt.includes(value) ? utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient : utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulClient;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        client.getEntries({
                                            contentType: "page",
                                            additionalQueryParams: {
                                                "fields.slug": value
                                            }
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    data = (response === null || response === void 0 ? void 0 : (ref = response.items) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.fields) || {};
                                    return [
                                        2,
                                        {
                                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                                                metaData: {
                                                    metaTitle: data.metaTitle || "",
                                                    metaDescription: data.metaDescription || "",
                                                    metaRobots: data.metaRobots || "",
                                                    ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getFileUrl */ .qm)(data.ogImage)
                                                }
                                            })
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResult: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResultFallback: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql,
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery, useGetPageSearchResultQuery = pageApi.useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery = pageApi.useGetPageSearchResultFallbackQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (pageApi);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.breadcrumpsTitle */ .y2.portfolio.breadcrumpsTitle
            });
            if (title && slug) {
                var cleanTitle = (title === null || title === void 0 ? void 0 : title.replace(/\s*\[Case Study\].*$/, "").trim()) || "";
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: cleanTitle
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 18584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"file":"styles_file__Wn8Kr","uploading":"styles_uploading__cx3iV","successUploading":"styles_successUploading__Wg3zy"};

/***/ }),

/***/ 17095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ZtH0P","onSuccess":"styles_onSuccess__0UPJq","form-title":"styles_form-title__EBlL5","form-description":"styles_form-description__LDiMX","formFields":"styles_formFields___5cMz","imputName":"styles_imputName__f_b5d","imputPhone":"styles_imputPhone__FDYrB","imputEmail":"styles_imputEmail__3jADp","imputDescription":"styles_imputDescription__J4Gyw","uploadFile":"styles_uploadFile__9y9xG","form-footer":"styles_form-footer__2J8tk","submit-button":"styles_submit-button__I4mNf","input":"styles_input__IUf6j","price-list":"styles_price-list__IQmzi","price":"styles_price___iRBC","checked":"styles_checked__jbR4W","prices-title":"styles_prices-title__YcCuq","attachedFiles":"styles_attachedFiles__ejgTS","moreFilesLink":"styles_moreFilesLink__GvVzC","hide":"styles_hide__oZ_KL","form-alert":"styles_form-alert__K1jM_","error-message":"styles_error-message__8QeVU"};

/***/ }),

/***/ 91979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__B8LQP","error":"styles_error__6v2ur","attached":"styles_attached__j_Fm3"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);